import { requestType } from '~/config/enum.config';
var SERVICE = 'domain-service';
var CONTROLLER = 'mailMessageController';
export default {
    /**
     * 发送邮件催收
     */
    sendMail: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'sendMail',
        type: requestType.Post
    }
};
